export const authFetch = async (url, options = {}) => {
    // Initialize cookies
    const arst_cookie = useCookie('arst');
    const uat_cookie = useCookie('auat');
    const user_id_cookie = useCookie('uid');

    const requestOptions = {...options};

    requestOptions.headers = {
        app: 'pp',
        'Accept': 'application/json',
        ...options.headers,
    };

    // Only set Content-Type if not already set and not FormData
    if (!options.headers?.['Content-Type'] && !(options.body instanceof FormData)) {
        requestOptions.headers['Content-Type'] = 'application/json';
    }

    if (arst_cookie.value) {
        requestOptions.headers['revocable-session-token'] = `${arst_cookie.value}`;
    }

    if (uat_cookie.value) {
        requestOptions.headers.access_token = `${uat_cookie.value}`;
        requestOptions.headers.Authorization = `Bearer ${uat_cookie.value}`;
    }

    if (user_id_cookie.value) {
        requestOptions.headers.user_id = `${user_id_cookie.value}`;
    }

    return $fetch(url, requestOptions);
};
